module.exports = __webpack_public_path__ + "static/img/balloon.f8bb5c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/balloon.svg
// module id = MKxt
// module chunks = 1